<script>
import HeadNav from '@/components/User/Compete/common/HeadNav';
import NavBar from '@/components/NavBar';
import Footer from '@/components/Footer';

export default {
  name: 'CompeteLayout',
  components: {
    HeadNav,
    NavBar,
    Footer,
  },
  data() {
    return {

    };
  },
};
</script>

<template lang="pug">
.application
  //- head-nav.header
  .header
    NavBar
  .main-content
    slot
  .footer
    Footer
</template>

<style lang="stylus" scoped>
.application
  display flex
  min-height 100vh
  flex-direction column
  .footer
    flex 1
  .main-content
    min-height calc(100vh - 220px)
    flex 1
</style>



// WEBPACK FOOTER //
// CompeteLayout.vue?9dfa0e32